import { render, staticRenderFns } from "./TableTicketsReports.vue?vue&type=template&id=50d13e8d"
import script from "./TableTicketsReports.vue?vue&type=script&lang=js"
export * from "./TableTicketsReports.vue?vue&type=script&lang=js"
import style0 from "./TableTicketsReports.vue?vue&type=style&index=0&id=50d13e8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports